import { render } from "./shareCourse.vue?vue&type=template&id=3bf429f7&scoped=true"
import script from "./shareCourse.vue?vue&type=script&lang=js"
export * from "./shareCourse.vue?vue&type=script&lang=js"

import "./shareCourse.vue?vue&type=style&index=0&id=3bf429f7&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf429f7"]])

export default __exports__